export const MIN_OFFER_AMOUNT_USD = 1;
